// extracted by mini-css-extract-plugin
export default {"form":"Search_form__F-9gv","input":"Search_input__AdkDR"};